module.exports = __webpack_public_path__ + "assets/img/join2021_004.08e455d8.png";